import useScrollAnimation from "@/hooks/useScrollAnimation";
import { technologiesData } from "@/mocks/homeData";

export default function TechnologiesSection() {
  const { ref, isVisible } = useScrollAnimation(0.08);

  return (
    <section id="technologies" className="w-full py-16 md:py-24 bg-background-50">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {technologiesData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {technologiesData.headline}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {technologiesData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
          {technologiesData.categories.map((cat) => (
            <div
              key={cat.name}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="flex items-center justify-between mb-4">
                <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                  {cat.name}
                </h4>
                <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                  {cat.proficiency}%
                </span>
              </div>
              <div className="flex flex-wrap gap-2">
                {cat.techs.map((tech) => (
                  <span
                    key={tech}
                    className="px-2.5 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200/70"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}